<template>
    <div name="description-of-soldoc3" class="description-of-soldoc3">
        <div class="description-of-soldoc3-inner">
            <h3>더 많은 환자를<br>더 효율적으로</h3>
            <div class="container">                
                <div class="section-container1">
                    <p class="subject">진료 외 기타 프로세스를 혁신적으로 간소화하여<br>효율적인 대면/비대면 진료가 가능합니다</p>
                    <div class="gif-area">
                        <p>기존 시간 당 진료 가능 인원</p>
                        <img class="mouse-arrow" src="../../assets/partners_pc/img_description_of_soldoc6.gif" alt="">
                        <p><strong>솔닥파트너스</strong>를 통한 진료 가능 인원 | <strong class="primary">단위 시간당 진료 인원 평균 90% 상승</strong></p>
                    </div>
                </div>
                <div class="section-container2">
                    <div class="accordion-list">
                        <div class="accordion-item" v-for="(item, index) in accordionItems" :key="index">
                            <button type="button" class="title" @click="open(index)">
                                <span class="num">0{{ index + 1 }}</span><strong class="tit">{{ item.title }}</strong>
                            </button>
                            <transition
                                name="accordion"
                            >
                                <div class="content" v-show="selected === index">
                                    <div class="inner">
                                        <p>{{ item.content1 }}</p>
                                        <p>{{ item.content2 }}</p>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "description-of-soldoc3",
    data: function() {
        return {
            selected: 0,
			accordionItems: [
				{ title: '솔닥 어드민에서 바로 차팅하세요', content1: '솔닥으로 접수된 진료는 기존 차트에 옮겨적지 않고', content2: '쉽고 직관적인 솔닥 어드민에서 바로 차팅할 수 있습니다.', isOpen: false },
				{ title: '모바일 예진지 미리 전달하세요', content1: '환자와의 소통이 한결 수월해지는 예진지로', content2: '불필요하게 낭비되는 진료 시간을 단축하세요.', isOpen: false },
				{ title: '각종 진료 서류, 클릭 한 번으로 발급하세요', content1: '직접 작성하고 출력해서 스캔할 필요 없이', content2: '클릭 한 번으로 간편하게 환자 앱으로 전송하세요.', isOpen: false },
			],
		};
    },
    computed: {},
    mounted: function() {
        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".description-of-soldoc3-inner").offset().top;
            var aniTitle = $(".description-of-soldoc3-inner h3");
            var aniItem = $(".description-of-soldoc3-inner .container");

            if (height <= 0) {
                $(aniTitle).removeClass('item-show').addClass('item-hide');
                $(aniItem).removeClass('item-show').addClass('item-hide');
            } else if (height > innerTop - 500 && height < innerTop + 1600) {
                $(aniTitle).removeClass('item-hide').addClass('item-show');
                $(aniItem).removeClass('item-hide').addClass('item-show');
            } else if (height > innerTop + 1600) {
                $(aniTitle).removeClass('item-show').addClass('item-hide');
                $(aniItem).removeClass('item-show').addClass('item-hide');
            }
        });
    },
    methods: {
        open(index) {
            this.selected = this.selected === index ? null : index;
        },
        start(el) {
            el.style.height = el.scrollHeight + "px";
        },
        end(el) {
            el.style.height = "";
        },
    },
};
</script>

<style scoped>
.description-of-soldoc3 {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 1580px;
    background: #FFF;
    overflow: hidden;
}
.description-of-soldoc3 .description-of-soldoc3-inner {  
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1240px;
    padding: 106px 20px 204px;
}
.description-of-soldoc3 .description-of-soldoc3-inner h3 {
    min-height: 123px;
    margin-bottom: 0;
    text-align: center;
    font-size: 46px;
    font-weight: 600;
    line-height: 60px;
    color: #000;
}
.description-of-soldoc3-inner .container {
    position: relative;
    width: 100%;
    visibility: hidden;
    opacity: 0;
}
.description-of-soldoc3-inner .item-hide {
    visibility: hidden;
    opacity: 0;
}
.description-of-soldoc3-inner .item-show {
    visibility: visible;
    opacity: 1;
    animation: fadeInUp1 2s;
}
.description-of-soldoc3 .section-container1 {
    width: 100%;
    margin-top: 32px;
}
.description-of-soldoc3 .section-container1 .subject {
    margin-bottom: 57px;
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    color: #1A1A1A;
    text-align: center;
}
.description-of-soldoc3 .section-container1 .gif-area {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.description-of-soldoc3 .section-container1 .gif-area p:first-child {
    position: relative;
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #999;
}
.description-of-soldoc3 .section-container1 .gif-area p:first-child::before {
    content: '';
    position: absolute;
    bottom: -111px;
    left: calc(50% - 409px);
    width: 818px;
    height: 106px;
    border-radius: 100px;
    background: #F6F6F6;
}
.description-of-soldoc3 .section-container1 .gif-area p:first-child::after {
    content: '';
    position: absolute;
    bottom: -95px;
    left: -222px;
    width: 74px;
    height: 74px;
    border-radius: 50%;
    background: #D9D9D9;
    box-shadow: 180px 0 0 0 #D9D9D9, 360px 0 0 0 #D9D9D9, 540px 0 0 0 #D9D9D9;
}
.description-of-soldoc3 .section-container1 .gif-area img {
    width: 818px;
    height: 106px;
    margin-top: 130px;
}
.description-of-soldoc3 .section-container1 .gif-area p:last-child {
    margin-top: 12px;
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #1A1A1A;
}
.description-of-soldoc3 .section-container1 .gif-area p:last-child strong {
    font-weight: 600;
}
.description-of-soldoc3 .section-container1 .gif-area p:last-child strong.primary {
    font-weight: 700;
    color: #008DEF;
}
.description-of-soldoc3 .section-container2 {
    width: 100%;
    margin-top: 196px;
}
.description-of-soldoc3 .section-container2 .accordion-list {
    border-top: 2px solid #008DEF;
    border-bottom: 2px solid #D9D9D9    
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item {
    margin: 0;
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item + .accordion-item {
	border-top: 1px solid #D9D9D9;
}
.description-of-soldoc3 .section-container2 .accordion-list .title {
    position: relative;
	width: 100%;
    height: 109px;
    padding-left: 82px;
    cursor: pointer;
	border: 0;
	background-color: transparent;
}
.description-of-soldoc3 .section-container2 .accordion-list .title .num {
    position: absolute;
    top: 37px;
    left: 82px;
    font-size: 28px;
    font-weight: 600;
    color: #008DEF;
    line-height: 36px;
}
.description-of-soldoc3 .section-container2 .accordion-list .title .tit {
    position: absolute;
    top: 37px;
    left: 160px;
    font-size: 28px;
    font-weight: 600;
    color: #000;
    line-height: 36px;
}
.description-of-soldoc3 .section-container2 .accordion-list .content .inner {
	height: 179px;
	padding: 0 0 0 160px;
}
.description-of-soldoc3 .section-container2 .accordion-list .content .inner p {
	margin-bottom: 0;
	font-size: 18px;
	font-weight: 400;
	line-height: 28px;
	color: #1A1A1A;
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item .inner {
	position: relative;
	margin-top: -9px;
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item:first-child .inner::before {
	content: '';
	position: absolute;
	right: 66px;
    bottom: -1px;
	width: 383px;
	height: 232px;
    background: url(../../assets/partners_pc/img_description_of_soldoc7.png) 0 0 no-repeat;
    background-size: 383px auto;
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item:nth-child(2) .inner::before {
	content: '';
	position: absolute;
	right: 66px;
    bottom: 0;
	width: 462px;
    height: 231px;
    background: url(../../assets/partners_pc/img_description_of_soldoc8.png) 0 0 no-repeat;
    background-size: 462px auto;
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item:last-child .inner::before {
	content: '';
	position: absolute;
	right: 66px;
    bottom: 0;
	width: 223px;
	height: 230px;
    background: url(../../assets/partners_pc/img_description_of_soldoc9.png) 0 0 no-repeat;
    background-size: 223px auto;
}
@keyframes fadeInUp1 {
    0% {
        opacity: 0;
        transform: translate3d(0, 30%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
@keyframes fadeInUp2 {
    0% {
        opacity: 0;
        transform: translate3d(0, 70%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pc_partners/DescriptionOfSoldoc3.vue